import script from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=js"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=154089ff&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154089ff"]])

export default __exports__